import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CoreConstants } from "../../../../../../../core/models/constants/core.constants";
import DynamicForm from "../../../../../../../core/presentations/DynamicForm";
import Validators from "../../../../../../../ui/helpers/validators";
import RightLabelFieldTemplate from "../../../../../../../ui/templates/fields/RightLabelFieldTemplate";
import TopLabelFieldTemplate from "../../../../../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../../../../../ui/templates/objects/VerticalFormTemplate";

const UserPersonalDetails = (props: any) => {

  const {onError, onSubmit, submitButton} = props;
  const { t } = useTranslation();
  const [formData, setFormData] = useState(null);

  const onChange = (formData: any) => {
    setFormData(formData);
  };

  const schema: any = {
    type: "object",
    properties: {
      avatar: {
        type: "string",
        title: t("users.label.userProfilePhoto"),
      },
      firstName: {
        type: "string",
        title: t("users.label.firstName"),
      },
      lastName: {
        type: "string",
        title: t("users.label.lastName"),
      },
      primaryPhoneNumber: {
        type: "string",
        title: t("users.label.primaryPhoneNumber"),
      },
      secondaryPhoneNumber: {
        type: "string",
        title: t("users.label.secondaryPhoneNumber"),
      },
      primaryEmailId: {
        type: "string",
        title: t("users.label.primaryEmailId"),
      },
      secondaryEmailId: {
        type: "string",
        title: t("users.label.secondaryEmailId"),
      },
      address: {
        type: "string",
        title: t("users.label.address"),
      },
      stateOrProvince: {
        type: "string",
        title: t("users.label.stateOrProvince"),
      },
      country: {
        type: "string",
        title: t("users.label.country"),
      },
      zipCode: {
        type: "number",
        title: t("users.label.zipCode"),
      },
    },
    required: [
      "firstName",
      "lastName",
      "primaryEmailId",
    ],
  };

  const validationSchema: any = {
    firstName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "users.validation.firstNameRequired",
        },
      ],
    },
    lastName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "users.validation.lastNameRequired",
        },
      ],
    },
    primaryPhoneNumber: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isValidPhoneNumber(value);
          },
          messageKey: "users.validation.phoneNumberInvalid",
        },
      ],
    },
    secondaryPhoneNumber: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isValidPhoneNumber(value);
          },
          messageKey: "users.validation.phoneNumberInvalid",
        },
      ],
    },
    primaryEmailId: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "users.validation.emailRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isRegexPatternValid(
              CoreConstants.REGEX_EMAIL,
              value
            );
          },
          messageKey: "users.validation.emailInvalid",
        },
      ],
    },
    secondaryEmailId: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isRegexPatternValid(
              CoreConstants.REGEX_EMAIL,
              value
            );
          },
          messageKey: "users.validation.emailInvalid",
        },
      ],
    },
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    avatar: {
      "ui:widget": "prwImageUpload",
      "ui:FieldTemplate": RightLabelFieldTemplate,
      classNames: "p-col-12",
    },
    firstName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    lastName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    primaryPhoneNumber: {
      "ui:widget": "prwPhoneNumber",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    secondaryPhoneNumber: {
      "ui:widget": "prwPhoneNumber",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    primaryEmailId: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    secondaryEmailId: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    address: {
      "ui:widget": "prwInputTextArea",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    stateOrProvince: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    country: {
      "ui:widget": "prwCountryDropdown",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    zipCode: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-12",
      "ui:emptyValue": "",
    },
  };

  return (
    <div>
      <DynamicForm
            onChange={onChange}
            formData={formData}
        onSubmit={onSubmit}
        onError={onError}
        schema={schema}
        uiSchema={uiSchema}
        validationSchema={validationSchema}
        formButtons={() => submitButton()}
      ></DynamicForm>
    </div>
  );
};

export default UserPersonalDetails;
